import { css } from "styled-components";

export const cardStyles = css`
  padding: 20px 40px 20px 40px;
  border-radius: 1rem;
  background-color: #fff;
  color: #000;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  cursor: pointer;
`;
